/**
 * i18n initialization for JackRoyals.
 *
 * - English (en) is the default + fallback
 * - Spanish (es) is the secondary locale
 * - Browser language is auto-detected on first visit
 * - User selection persists in localStorage under "i18nextLng"
 *
 * Usage in components:
 *   import { useTranslation } from "react-i18next";
 *   const { t } = useTranslation();
 *   <button>{t("buy_now")}</button>
 *
 * Usage outside React (e.g. toast messages in services):
 *   import i18n from "../i18n";
 *   toast.success(i18n.t("purchase_complete"));
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    interpolation: { escapeValue: false }, // react already escapes
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    react: { useSuspense: false }, // avoid suspense boundary requirement for first paint
  });

export default i18n;
